// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/sezionali-iva?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, societaId, codice, descrizione, isDefault, ultimoNumero, ultimoAnno, attivo, note }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/sezionali-iva',
    requestBody: '{ societaId, codice, descrizione, isDefault, note }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/sezionali-iva/:id',
    requestBody: '{ codice, descrizione, note }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/sezionali-iva/:id/default',
    requestBody: '{ isDefault }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/sezionali-iva/:id/stato',
    requestBody: '{ attivo }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/sezionali-iva/:id',
    requestBody: null,
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
